import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Row, Col } from 'antd';

import ReconciliationDetailsBox from '~pages/reconciliation/detail/details-box';
import ReconciliationOpportunityDetails from '~components/reconciliation-opportunity-details';
import ReconciliationUserInfo from '~components/reconciliation-user-info';

const ReconciliationDetails = ({ booking }) => {
  const { t } = useTranslation();
  const history = useHistory();

  const handleGoBack = () => {
    history.goBack();
  };

  return (
    <div className="reconciliation-details">
      <div className="reconciliation-details__header">
        <p className="reconciliation-details__crumb">
          <span
            to="/reconciliation"
            className="reconciliation-details__link"
            onClick={handleGoBack}
          >
            {`${t('landlord.breadcrumb.reconciliation_list')} / `}
          </span>
          {t('landlord.breadcrumb.reconciliation_detail')}
        </p>
        <p className="reconciliation-details__booking-number">
          {t('landlord.booking.reconciliation.header.booking_number', {
            referenceId: booking?.completedXbooking?.referenceId || '',
          })}
        </p>
      </div>

      <div className="reconciliation-details__content">
        <Row gutter={[24, 24]}>
          <Col span={7} className="reconciliation-details__col">
            <div className="reconciliation-details__block">
              <ReconciliationDetailsBox opportunityId={booking.id} opportunityDetails={booking} />
            </div>
          </Col>
          <Col span={12} className="reconciliation-details__col">
            <div className="reconciliation-details__block">
              <ReconciliationOpportunityDetails opportunityDetails={booking} />
            </div>
          </Col>
          <Col span={5} className="reconciliation-details__col">
            <div className="reconciliation-details__block">
              <ReconciliationUserInfo userInfo={booking?.student ?? {}} />
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default ReconciliationDetails;
